export class Constants {
    static readonly DATE_FMT_TO_SERVICE = 'yyyy-MM-dd';
    static readonly DATE_FMT_TO_UI = 'MM/dd/yyyy';
  }